import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { OrderService } from 'src/app/services/order.service';
import { HttpAlertService } from 'src/app/services/http-alert.service';

@Component({
  selector: 'app-prepaid-by-code',
  templateUrl: './prepaid-by-code.component.html',
  styleUrls: ['./prepaid-by-code.component.scss']
})
export class PrepaidByCodeComponent implements OnInit {
  prepaidAmount: number;
  prepaidCodeForm: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private orderService: OrderService,
    private httpAlertService: HttpAlertService
  ) {
    this.prepaidCodeForm = this.formBuilder.group({
      code: ['', [Validators.required, Validators.minLength(12), Validators.maxLength(12)]]
    });
  }

  ngOnInit(): void {
  }

  public onPrepaidCodeFormSubmit() {
    if (this.prepaidCodeForm.valid) {
      this.orderService.prepaidByCode(this.prepaidCodeForm.value).subscribe(response => {
        if (response.success) {
          this.router.navigate(['/transaction-completed'], { queryParams: { amount: response.data.prepaid_value } });
        } else {
          this.httpAlertService.error(response.message);
        }
      }, (err) => {
        this.httpAlertService.error(err.message);
      });
    }
  }

}
